/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_2_BInputs */



/**
* | output |
* | --- |
* | "Detection accuracy directly depends on the quality and completeness of your configured regex templates" |
*
* @param {Guardrails_Section_2_BInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_2_b = /** @type {((inputs?: Guardrails_Section_2_BInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_2_BInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("die Erkennungsgenauigkeit unmittelbar von der Qualität und Vollständigkeit der von Ihnen konfigurierten Regex-Templates abhängt")
	return /** @type {LocalizedString} */ ("Detection accuracy directly depends on the quality and completeness of your configured regex templates")
});